import { Route } from '@angular/router';

export const NotificationBatchRoutes: Route[] = [
  {
    path: 'notification-batch',
    loadComponent: () => import('../pages/notification-batch/notification-batch.page'),
  },
];
